document.addEventListener("click", (event) => {
  if (event.target.tagName === "BUTTON" && event.target.classList.contains("swatch")) {
    const cardContent = event.target.closest(".card__content");
    if (!cardContent) return;
    
    event.stopPropagation();
    const swatchWrapper = event.target.parentNode;
    const swatchGroup = swatchWrapper.parentNode;
    
    const cardElement = event.target.closest(".card");
    const imagesWithDataValue = cardElement.querySelectorAll("img[data-value]");
    
    if (imagesWithDataValue.length === 0) {
      const productLink = cardElement.querySelector("a[href]");
      if (productLink) {
        window.location.href = productLink.href;
        return;
      }
    }
    
    swatchWrapper.classList.add("selected");
    event.target.setAttribute("aria-pressed", "true");
    
    Array.from(swatchGroup.children).forEach((sibling) => {
      if (sibling !== swatchWrapper) {
        sibling.classList.remove("selected");
        const siblingButton = sibling.querySelector(".swatch");
        if (siblingButton) {
          siblingButton.setAttribute("aria-pressed", "false");
        }
      }
    });
    
    cardElement.querySelectorAll("img").forEach((img) => {
      if (img.dataset.value == event.target.dataset.value) {
        img.classList.remove("hidden");
      } else {
        img.classList.add("hidden");
      }
    });
  }
});